import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useContext, useEffect, useMemo } from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import Measure from 'react-measure';
import { TabsContext, TabsItemContext } from './context';
import Flex from '../Flex';
import TabLine from './components/TabLine';
import TabBackdrop from './components/TabBackdrop';
import TabListWrapper from './components/TabListWrapper';
import { TABS_BUTTON_BACKDROP_SIZE } from './constants';
import { equalArrays } from '../helpers/arrays';
var SHOW_BACKDROPS = {
  xs: false,
  sm: true
};
var FULL_WIDTH_STYLE = {
  width: '100%'
};

var TabList = function TabList(_ref) {
  var _ref$showBackdrops = _ref.showBackdrops,
      showBackdrops = _ref$showBackdrops === void 0 ? SHOW_BACKDROPS : _ref$showBackdrops,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$float = _ref.float,
      float = _ref$float === void 0 ? 'left' : _ref$float,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      children = _ref.children,
      paddingHorizontal = _ref.paddingHorizontal,
      props = _objectWithoutPropertiesLoose(_ref, ["showBackdrops", "label", "float", "fullWidth", "children", "paddingHorizontal"]);

  var _useContext = useContext(TabsContext),
      refs = _useContext.refs,
      refsInner = _useContext.refsInner,
      refList = _useContext.refList,
      tabNames = _useContext.tabNames,
      onLineReset = _useContext.onLineReset,
      resize = _useContext.resize,
      selected = _useContext.selected,
      selectedPrevious = _useContext.selectedPrevious;

  var childrenArray = useMemo(function () {
    return React.Children.toArray(children);
  }, [children]); // processing new tabs

  useEffect(function () {
    var newTabNames = childrenArray.map(function (el) {
      var _el$props;

      return (_el$props = el.props) == null ? void 0 : _el$props.name;
    });

    if (!equalArrays(newTabNames, tabNames.current)) {
      tabNames.current = newTabNames;
    }
  }, [childrenArray]);

  var _ref3 = /*#__PURE__*/React.createElement(TabBackdrop, {
    $show: showBackdrops,
    position: 'left',
    inverse: true,
    width: TABS_BUTTON_BACKDROP_SIZE
  });

  var _ref4 = /*#__PURE__*/React.createElement(TabBackdrop, {
    $show: showBackdrops,
    position: 'right',
    inverse: true,
    width: TABS_BUTTON_BACKDROP_SIZE
  });

  return /*#__PURE__*/React.createElement(Measure, {
    onResize: function onResize() {
      return resize(false);
    }
  }, function (_ref2) {
    var measureRef = _ref2.measureRef;
    return /*#__PURE__*/React.createElement(TabListWrapper, _extends({
      direction: 'ltr',
      justify: float === 'right' ? 'end' : 'start',
      role: "tablist",
      "aria-label": label,
      ref: measureRef,
      $paddingHorizontal: paddingHorizontal
    }, props), /*#__PURE__*/React.createElement(ScrollContainer, {
      vertical: false,
      horizontal: true,
      hideScrollbars: true,
      ref: refList,
      style: fullWidth ? FULL_WIDTH_STYLE : null
    }, /*#__PURE__*/React.createElement(Flex, {
      direction: 'ltr',
      wrap: false,
      style: {
        position: 'relative'
      }
    }, childrenArray.map(function (element, index) {
      return /*#__PURE__*/React.createElement(TabsItemContext.Provider, {
        key: index,
        value: {
          index: index,
          first: index === 0,
          last: index === childrenArray.length - 1,
          fullWidth: fullWidth
        }
      }, element);
    }), /*#__PURE__*/React.createElement(TabLine, {
      onLineReset: onLineReset,
      refCurrent: !selected ? null : refs.current[selected],
      refCurrentInner: !selected ? null : refsInner.current[selected],
      refPrevious: !selectedPrevious ? null : refs.current[selectedPrevious]
    }))), _ref3, _ref4);
  });
};

export default TabList;